import { api } from './api';

/* Mirrors Eduvora.Domain.Usage. Money is always paise on the wire — a float rupee value that has
   been through JSON is not a figure you want in an argument about a bill. */

export interface ChannelUsage {
  channel: number;
  label: string;
  unit: string;
  used: number;
  allowance: number | null;
  spentPaise: number;
  budgetPaise: number | null;
  events: number;
  failed: number;
  percentUsed: number | null;
  /** Already formatted, and it is not the same kind of thing on every row — see the C# note. */
  limitLabel: string | null;
  /** 0 fine, 1 approaching, 2 over. */
  level: 0 | 1 | 2;
  /** ⚠ When set, this channel cannot send at all. Render it INSTEAD of the zero. */
  notWiredNote: string | null;
}

export interface UsageReport {
  period: { from: string; to: string; label: string };
  channels: ChannelUsage[];
  totalSpentPaise: number;
  warnings: string[];
  enforcementNote: string;
}

export interface UsageLogRow {
  at: string;
  channel: string;
  outcome: string;
  purpose: string;
  quantity: number;
  costPaise: number;
  recipientHint: string | null;
  source: string | null;
  encoding: string | null;
  model: string | null;
  error: string | null;
}

export const usageApi = {
  thisMonth: () => api.get<UsageReport>('/api/usage'),
  log: (channel?: string, take = 100) =>
    api.get<UsageLogRow[]>(
      `/api/usage/log?take=${take}${channel ? `&channel=${encodeURIComponent(channel)}` : ''}`,
    ),
};

/** ₹ from paise. Two decimals always — a bill never says "₹5.4". */
export function rupees(paise: number): string {
  return '₹' + (paise / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
